if (!process.env.CVNA_APP_APIK_BASE_URL) {
  throw new Error('Base URL environment variable(s) missing.');
}

export const APIK_BASE_URL = process.env.CVNA_APP_APIK_BASE_URL;

/* SEO API ENDPOINTS */

export const SEO_CONTENT_CLIENT = `${APIK_BASE_URL}/traffic/content`;
export const SEO_REVIEWS_CLIENT = `${APIK_BASE_URL}/traffic/reviews/v4`;
export const SEO_LINKS_CLIENT = `${APIK_BASE_URL}/traffic/links/v3/kill/byurl`;

/* CORE API ENDPOINTS */

export const USER_PROFILE = `${APIK_BASE_URL}/core/user-profile-api/api/graph`;
export const CONTACTS = `${APIK_BASE_URL}/core/contacts/api/v1/details/`;

/* CONTEXT API ENDPOINTS */

export const GET_FAVORITES = `${APIK_BASE_URL}/merch/carvanamerchcontextapi/api/v3/favorites`;
export const ADD_FAVORITES = `${APIK_BASE_URL}/merch/carvanamerchcontextapi/api/v3/favorites/add`;
export const REMOVE_FAVORITES = `${APIK_BASE_URL}/merch/carvanamerchcontextapi/api/v3/favorites/remove`;

export const DELIVERY_CONTEXT = `${APIK_BASE_URL}/merch/carvanamerchcontextapi/api/v3/delivery`;

/* SEARCH API ENDPOINTS */

export const INVENTORY = `${APIK_BASE_URL}/merch/search/api/v2/search`;
export const FACET_DATA = `${APIK_BASE_URL}/merch/search/api/v2/search/facets`;
export const PRICING = `${APIK_BASE_URL}/merch/search/api/v2/pricing`;
export const SUGGESTIONSV3 = `${APIK_BASE_URL}/merch/search/api/v3/suggest`;

/* SAVED SEARCH API ENDPOINTS */

export const SAVED_SEARCH = `${APIK_BASE_URL}/merch/savedsearch/api/v2/savedsearch`;

export const AVAILABILITY = `${APIK_BASE_URL}/merch/buffering/api/v1/soonestavailabilitybulk`;

/* FINANCE API ENDPOINTS */

export const CREDIT_STATUS = `${APIK_BASE_URL}/fin/finxapi/api/v1/finance/credit-status`;

/* TRADE API ENDPOINTS */

export const TRADES = `${APIK_BASE_URL}/stc/trades/api/v3/appraisal/summaries`;
